import {LOCATION_TYPE} from "./constants.js";

export const YMD_HM = (date) => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        dt = date;
    } else {
        dt = new Date(date);
    }

    return `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())} ${pad0(dt.getHours())}:${pad0(dt.getMinutes())}`;
}

export const YMD = (date) => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        dt = date;
    } else {
        dt = new Date(date);
    }

    return `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())}`;
}

export const DMY = (date) => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        dt = date;
    } else {
        dt = new Date(date);
    }

    return `${pad0(dt.getDate())}-${pad0(dt.getMonth() + 1)}-${dt.getFullYear()}`;
}

export const DMY_HM = (date) => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        dt = date;
    } else {
        dt = new Date(date);
    }

    return `${pad0(dt.getDate())}-${pad0(dt.getMonth() + 1)}-${dt.getFullYear()} ${pad0(dt.getHours())}:${pad0(dt.getMinutes())}`;
}

export const HM = (date) => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        dt = date;
    } else {
        dt = new Date(date);
    }

    return `${pad0(dt.getHours())}:${pad0(dt.getMinutes())}`;
}

export const addToDate = (date, plus = 0, origin = 'day') => {
    let dt = date ? new Date(date) : new Date();

    if (isNaN(dt)) {
        throw new Error("Μη έγκυρη ημερομηνία");
    }

    switch (origin) {
        case 'day':
            dt.setDate(dt.getDate() + plus);
            break;
        case 'month':
            dt.setMonth(dt.getMonth() + plus);
            break;
        case 'year':
            dt.setFullYear(dt.getFullYear() + plus);
            break;
        default:
            throw new Error("Το origin πρέπει να είναι 'day', 'month' ή 'year'");
    }

    return dt;
}

export const pad0 = x => x.toString().padStart(2, "0");

export const setFocusTo = (element_id, delay = 280) => {
    if (element_id) {
        setTimeout(function () {
            let element = document.getElementById(element_id);
            if (element) element.focus();
        }, delay);
    }
}

export const isInViewport = (element_id) => {
    if (!element_id) {
        return false;
    }

    const element = document.getElementById(element_id);
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export const upCaseStr = str => {
    if (!str) {
        return "";
    }

    let arr = [['Ά', 'Α'], ['Έ', 'Ε'], ['Ή', 'Η'], ['Ί', 'Ι'], ['Ϊ', 'Ι'], ['Ό', 'Ο'], ['Ύ', 'Υ'], ['Ϋ', 'Υ'], ['Ώ', 'Ω']];
    str = str.toUpperCase();
    arr.map(chars => {
        str = str.split(chars[0]).join(chars[1]);
    });
    return str;
}

export const trim = (str) => {
    if (str == null) {
        return '';
    }

    if (str.constructor === String) {
        return str.trim();
    }

    return str;
}

export const isEmpty = (obj) => {
    if (obj === undefined || obj == null) {
        return true;
    }

    if (obj.constructor === String) {
        return obj.trim().length == 0;
    }

    return false;
}

export function isValidEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
}

export const isValidPhone = phone => {
    const phoneRegex = /^\+\d{10,}$/;
    return phoneRegex.test(phone);
};

export const rawPhone = (phone) => {
    return phone ? phone.replace(/\s+/g, "") : '';
}

export const isNumber = value => {
    return parseInt(value).toString() === value.toString();
}

export const copyObject = obj => {
    if (!obj) return null;
    return JSON.parse(JSON.stringify(obj));
}

export const sort = (array, key, descending) => {
    if (descending) {
        return array.sort((a, b) => (a[key] < b[key] ? 1 : -1));
    }

    return array.sort((a, b) => (a[key] > b[key] ? 1 : -1));
}

export const hasFlightNo = (pickup, drop) => {
    return (pickup && pickup?.type_id == LOCATION_TYPE.AIRPORT) || (drop && drop?.type_id == LOCATION_TYPE.AIRPORT);
}

export const hasBoatName = (pickup, drop) => {
    return (pickup && pickup?.type_id == LOCATION_TYPE.PORT) || (drop && drop?.type_id == LOCATION_TYPE.PORT);
}

export const hasRoomNo = (pickup, drop) => {
    return (drop && drop?.type_id == LOCATION_TYPE.HOTEL) || (pickup && pickup?.type_id == LOCATION_TYPE.HOTEL);
}

export const getDepartmentCode = () => {
    const match = window.location.pathname.match(/^\/([a-z0-9-]+)/);
    return match?.[1] ?? '';
}

export const scrollToTop = () => {
    setTimeout(() => {
        document.getElementById("formTop").scrollIntoView();
    }, 200);
}

export const formatPrice = (value) => {
    return `€${Number(value).toFixed(0)}`;
}

export const fnt = () => {};
